import { render, staticRenderFns } from "./MeshFrameDialog.vue?vue&type=template&id=464a851f"
import script from "./MeshFrameDialog.vue?vue&type=script&lang=js"
export * from "./MeshFrameDialog.vue?vue&type=script&lang=js"
import style0 from "./MeshFrameDialog.vue?vue&type=style&index=0&id=464a851f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports